import React from 'react'
import { Flex, type FlexProps } from '@chakra-ui/react'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { AnimatePresence, motion } from 'framer-motion'

interface CircleTimerProps extends FlexProps {
  duration: number
  isPlaying?: boolean
  onComplete?: () => void
  onUpdate?: (time: number) => void
}

const renderTime = ({
  remainingTime
}: {
  remainingTime: number
}): JSX.Element => {
  return (
    <Flex
      justifyContent="center"
      position="relative"
      width="80px"
      height="60px"
      fontSize="38px"
      fontFamily="Inter, sans-serif"
      fontWeight="800"
      sx={{
        '.time': {
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transform: 'translateY(0)',
          opacity: 1,
          transition: 'all 0.2s',
          color: '#2D3748'
        },
        '.waiting': {
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transform: 'translateY(0)',
          opacity: 1,
          transition: 'all 0.2s',
          color: '#2D3748',
          fontSize: '28px'
        }
      }}
    >
      <AnimatePresence>
        {remainingTime > 0 && (
          <motion.div
            className="time"
            key={remainingTime}
            initial={{ opacity: 0, transform: 'translateY(-100%)' }}
            animate={{ opacity: 1, transform: 'translateY(0)' }}
            exit={{ opacity: 0, transform: 'translateY(100%)' }}
          >
            {remainingTime}
          </motion.div>
        )}
        {remainingTime <= 0 && (
          <motion.div
            className="waiting"
            key={remainingTime}
            initial={{ opacity: 0, transform: 'translateY(-100%)' }}
            animate={{ opacity: 1, transform: 'translateY(0)' }}
            exit={{ opacity: 0, transform: 'translateY(100%)' }}
          >
            waiting
          </motion.div>
        )}
      </AnimatePresence>
    </Flex>
  )
}
export const CircleTimer = ({
  duration,
  isPlaying = true,
  onComplete = () => {},
  onUpdate = (time: number): void => {},
  ...rest
}: CircleTimerProps): JSX.Element => {
  return (
    <Flex {...rest}>
      <CountdownCircleTimer
        isPlaying={isPlaying}
        duration={duration} // use the duration prop
        updateInterval={1}
        colors="#2D3748"
        onComplete={onComplete}
        onUpdate={(time: number) => {
          onUpdate(time)
        }}
        size={100}
      >
        {renderTime}
      </CountdownCircleTimer>
    </Flex>
  )
}
